import {
  TBiddingWindowInfoData,
  IFetchBiddingWindowInfoResponse,
} from '../types';

/**
 * Transforms the raw bid window data into a structured format.
 */
export function formatBiddingInfoResponse(
  bidData: IFetchBiddingWindowInfoResponse['data']
): TBiddingWindowInfoData {
  if (bidData.biddingWindow) {
    return {
      type: 'ACTIVE',
      biddingWindow: bidData.biddingWindow,
      bidValidityConfiguration: bidData.bidValidityConfiguration,
    };
  }

  return {
    type: 'INACTIVE',
  };
}
